import React, { useEffect, useRef, useState } from "react";
import { Col,  FormGroup, Label, Spinner} from "reactstrap";
import { connect, useSelector } from "react-redux";
import { getStateByPath } from "../../../../redux/selectors";
import {
    ADD_STATE,
    REMOVE_STATE,
    setItem, setLoading,
} from "../../../../redux/actions/generics/IndexedActions";
import { genericIndexedActions } from "../../../../redux/actions/generics/GenericIndexedActions";
import { itineraryService } from "../../../../jwt/_services/eventx/ItineraryService";
import EventCustomCalendar from "../../../../components/calendar/EventCustomCalendar";
import {LB_EVENT} from "../../../../components/i18n/i18n";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {eventProvider} from "../../../../providers/eventx/eventProvider";
import {ActivityItinerarySectionForm} from "./_form";
import {eventService} from "../../../../jwt/_services/core/eventService";

const ActivityItinerarySection = (props) => {
    const path = props.path + "/itinerary";
    const [parent] = useState(props.parent || null); // Activity
    const [udn] = useState(props.udn || null);
    const [app] = useState(props.app || null);

    const componentState = useSelector((state) => getStateByPath(state, path));
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;

    const [itineraryItems, setItineraryItems] = useState([]);
    const [showItineraryModal, setShowItineraryModal] = useState(true);
    const itineraryModalRef = useRef(null);

    const [eventId, setEventId] = useState(parent.event?.id || null);
    const [event, setEvent] = useState(parent.event || null);


    //TODO: Esto debería ser manejado por el padre
    const [openingTime, setOpeningTime] = useState({ hour: 8,  min: 0 });
    const [closingTime, setClosingTime] = useState({ hour: 23,  min: 0 });

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);

    useEffect(() => {
        if (!parent.event?.id) return;

        setEventId(parent.event?.id);
    }, [props.event]);

    useEffect(() => {
        if (!listDomainObjects || listDomainObjects.length === 0) return;

        mapItemsToItinerary(listDomainObjects);
    }, [listDomainObjects]);

    useEffect(() => {
        if (!parent.event?.id) return;

        setLoading(path, true);
        eventService.getItem(parent.event?.id, app?.fbDataBase?.id)
            .then((response) => {
                if(!response) return;

                setEvent(response);
                const opening = response.openingTime.split(":");
                const closing = response.closingTime.split(":");
                setOpeningTime({
                    hour: opening[0],
                    min: opening[1]
                })
                setClosingTime({
                    hour: closing[0],
                    min: closing[1]
                })

                const dataRequest = {
                    fbDataBase: { id: app?.fbDataBase?.id },
                    item: {
                        event: { id: parent.event?.id },
                        activity: { id: parent?.id },
                    },
                };

                genericIndexedActions.search(path, itineraryService, 0, 1000, dataRequest);
            })
            .catch((error) => {
                console.log(error);
            })
    }, [parent.event]);

    const mapItemsToItinerary = (data) => {

        const items = data.map((item) => {
            // set opening based on earliest item.timeStart
            // if (!openingTime || item.timeStart < openingTime) {
            //     const opening = item.timeStart.split(":");
            //     setOpeningTime({
            //         hour: opening[0],
            //         min: opening[1]
            //     })
            // }
            // if (!closingTime || item.timeEnd > closingTime) {
            //     const closing = item.timeStart.split(":");
            //     setClosingTime({
            //         hour: closing[0],
            //         min: closing[1]
            //     })
            // }

            const startDateString = `${item.date}T${item.timeStart}`;
            const endDateString = `${item.date}T${item.timeEnd}`;
            return {
                id: item.id,
                title: item.activityName,
                start: new Date(startDateString),
                end: new Date(endDateString),
            };
        });

        setItineraryItems(items);
    };

    const notImplemented = (data) => {
        console.log(data);
    };

    const showMenuForm = (item, start, end) => {
        if (!eventId) {
            alert("Please select an event first");
            return;
        }


        setShowItineraryModal(true);
        itineraryModalRef.current.showModal(item, start, end, parent.category);
    };

    const onAddItineraryItem = (data) => {
        showMenuForm(null, data.start, data.end);
    };
    const onEditItineraryItem = (_item) => {
        // Busca el item en la lista de items
        const item = listDomainObjects.find((i) => i.id === _item.id);

        setItem(path, item);
        showMenuForm(item);
    };

    return (
        <>
            <div className={'form-container'}>
                <div className={''}>
                    <h2>{'Itinerario'}</h2>
                </div>
                <div className={"vertical-container media-section-body"}>
                    {/*<div>*/}
                    {/*    <Col md={'6'}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>{LB_EVENT}</Label>*/}
                    {/*            <SelectGeneric*/}
                    {/*                provider={eventProvider}*/}
                    {/*                initialValue={eventId}*/}
                    {/*                setExternalValue={setEventId}*/}
                    {/*                customFilter={{item: {udn: {id: udn?.id}}}}*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*</div>*/}
                    {loading ? (
                        <Spinner animation="border"/>
                    ) : (
                        <>
                            <EventCustomCalendar
                                path={path}
                                events={itineraryItems}
                                defaultDate={event?.startDate !== undefined ? new Date(event?.startDate) : new Date()}
                                //defaultDate={ event?.startDate !== undefined ? moment(event?.startDate).format("yyyy-MM-dd HH:mm") : new Date() }
                                //moment(domainObject?.startDate).format("yyyy-MM-dd") || new Date() }
                                minHour={openingTime}
                                maxHour={closingTime}
                                onSelectEvent={(event) => onEditItineraryItem(event)}
                                onSelectSlot={onAddItineraryItem}
                            />
                        </>
                    )}
                </div>
            </div>
            {showItineraryModal && (
                <ActivityItinerarySectionForm
                    path={props.path}
                    activity={parent}
                    category={parent?.category}
                    event={{id: eventId}}
                    udn={udn}
                    app={app}
                    ref={itineraryModalRef}
                />
            )}
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
    setLoading
};

export default connect(mapStateToProps, mapActionsToProps)(ActivityItinerarySection);
